import { jsx } from "react/jsx-runtime";
import { Grid } from "@elliemae/ds-grid";
import { DSControlledCheckbox } from "@elliemae/ds-form-checkbox";
import { DSFormLayoutBlockItem } from "@elliemae/ds-form-layout-blocks";
import _ from "lodash";
import { useFormState } from "react-hook-form";
import { useEffect, useMemo, useState } from "react";
import { useCheckboxFieldUpdateLogic } from "../utils/fieldUpdateLogic";
import { useFieldAutoSetValue } from "../utils/fieldAutoSetValue";
import { useFieldVisibilityAndDisability } from "../utils/fieldVisibilityAndDisability";
const Checkbox = ({
  renderedField,
  schemaForm,
  rules,
  name,
  label,
  required,
  pathValue,
  feedbackMessage,
  ui,
  visible,
  disabled,
  disableCheck,
  visibleCheck,
  valueHandler,
  preview
}) => {
  const checkboxUpdateLogic = useCheckboxFieldUpdateLogic();
  const { errors } = useFormState({ control: schemaForm.control });
  const errorMessage = _.get(errors, pathValue)?.message;
  const { isVisible, isDisabled } = useFieldVisibilityAndDisability({
    schemaForm,
    rules,
    visible,
    disabled,
    visibleCheck,
    disableCheck,
    preview
  });
  const [effectiveValue, setEffectiveValue] = useState(renderedField?.value);
  useEffect(() => {
    setEffectiveValue(renderedField?.value);
  }, [renderedField?.value]);
  useEffect(() => {
    if (pathValue !== "loanInformation.constructionRefinance") return;
    if (isVisible && renderedField?.value === void 0) {
      schemaForm.setValue(pathValue, false, { shouldDirty: false });
    } else if (!isVisible && renderedField?.value !== void 0) {
      schemaForm.setValue(pathValue, void 0, { shouldDirty: false });
    }
  }, [pathValue, isVisible, renderedField?.value, schemaForm]);
  useFieldAutoSetValue({
    schemaForm,
    rules,
    pathValue,
    valueHandler,
    preview,
    onAutoSet: setEffectiveValue
  });
  const isCustomCheckbox = useMemo(() => name.startsWith("CUSTOM"), [name]);
  const isChecked = useMemo(() => {
    if (isCustomCheckbox) {
      return effectiveValue === "True";
    }
    return effectiveValue ?? false;
  }, [effectiveValue, isCustomCheckbox]);
  return /* @__PURE__ */ jsx(
    Grid,
    {
      mt: "2px",
      gutter: "xs",
      height: "100%",
      wrap: "nowrap",
      alignItems: "center",
      justifyContent: "flex-start",
      span: ui.col_size ?? 2,
      cols: ["auto", "auto", "auto", "auto"],
      style: { display: isVisible ? "block" : "none" },
      children: /* @__PURE__ */ jsx(
        DSFormLayoutBlockItem,
        {
          inputID: `epps-field-id-${name}`,
          label,
          required,
          feedbackMessage,
          hasError: !!errorMessage,
          validationMessage: errorMessage,
          children: /* @__PURE__ */ jsx(
            DSControlledCheckbox,
            {
              ...renderedField,
              checked: isChecked,
              name,
              id: pathValue,
              onChange: checkboxUpdateLogic(
                renderedField,
                schemaForm,
                isCustomCheckbox
              ),
              disabled: isDisabled
            }
          )
        }
      )
    }
  );
};
export {
  Checkbox
};
